var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAgent)?_c('agent-ad-revenue'):_c('ad-revenue-query')
}
var staticRenderFns = []

export { render, staticRenderFns }